import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

const ViewDatesheet = () => {
  const { id } = useParams();
  const location = useLocation();
  const examFromState = location.state?.exam;
  const [examData, setExamData] = useState(examFromState || null);
  const [isEditing, setIsEditing] = useState(false);
  const navigate = useNavigate();
  // Helper to display date as MM/DD/YYYY
  const formatDateMMDDYYYY = (date) => {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  };

  // Fetch exam from backend if not passed via state
  useEffect(() => {
    const fetchExam = async () => {
      try {
        const sessionId = localStorage.getItem('currentSessionId');
        const response = await axios.get(
          ` ${process.env.REACT_APP_API_BASE_URL}/api/exams/getExam/${id}`,
          { params: { sessionId } }
        );
console.log("📦 Exam response from backend:", response.data);
console.log("📚 Subjects:", response.data.subjects);
        const formattedSubjects = response.data.subjects.map(sub => ({
          ...sub,
          examDate: new Date(sub.examDate).toISOString().split('T')[0], // YYYY-MM-DD for input
        }));

        setExamData({ ...response.data, subjects: formattedSubjects });
      } catch (err) {
        console.error('Error fetching exam:', err);
        alert('Failed to load exam data');
      }
    };

    fetchExam();
  }, [id, examFromState]);

  if (!examData) return <h2 className="text-center mt-10 text-red-500">Loading...</h2>;

  const handleChange = (index, field, value) => {
    const updatedSubjects = [...examData.subjects];
    updatedSubjects[index][field] = value;
    setExamData({ ...examData, subjects: updatedSubjects });
  };

  const handleExamNameChange = (e) => {
    setExamData({ ...examData, examName: e.target.value });
  };

  const handleSave = async () => {
    try {
      const payload = {
        ...examData,
        subjects: examData.subjects.map(sub => ({
          ...sub,
          examDate: new Date(sub.examDate), // convert to Date for backend
        })),
      };

      const response = await axios.put(
        ` ${process.env.REACT_APP_API_BASE_URL}/api/exams/updateExam/${examData._id}`,
        payload,
        { params: { sessionId: examData.session } }
      );

      const formattedSubjects = response.data.subjects.map(sub => ({
        ...sub,
        examDate: new Date(sub.examDate).toISOString().split('T')[0],
      }));

      setExamData({ ...response.data, subjects: formattedSubjects });
      setIsEditing(false);
      alert('Datesheet updated successfully');
       navigate('/exam-datesheet');
    } catch (err) {
      console.error(err);
      alert('Failed to update datesheet');
    }
  };

  return (
    <div className="max-w-full mx-auto p-6 bg-white shadow-2xl rounded-lg mt-3">
      <div className="flex justify-between items-center mb-6">
        {isEditing ? (
          <input
            type="text"
            value={examData.examName}
            onChange={handleExamNameChange}
            className="border p-2 rounded text-lg font-bold"
          />
        ) : (
          <h2 className="text-2xl font-bold text-center">
            Datesheet for {examData.class} - {examData.examName}
          </h2>
        )}

        <div>
          {isEditing ? (
            <>
              <button onClick={handleSave} className="bg-green-500 text-white px-4 py-2 rounded mr-2">
                Save
              </button>
              <button onClick={() => { setExamData(examFromState || examData); setIsEditing(false); }} className="bg-gray-400 text-white px-4 py-2 rounded">
                Cancel
              </button>
            </>
          ) : (
            <button onClick={() => setIsEditing(true)} className="bg-blue-500 text-white px-4 py-2 rounded">
              Edit
            </button>
          )}
        </div>
      </div>

      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-200">
          <tr>
            <th>Sr. No.</th>
            <th>Subject</th>
            <th>Date</th>
            <th>Timing</th>
            <th>Invigilator</th>
            <th>Room</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody className="bg-gray-100 divide-y divide-gray-200">
          {examData.subjects.map((sub, idx) => (
            <tr key={idx}>
              <td className="text-center">{idx + 1}</td>
              <td className="text-center">{sub.subjectName}</td>
              <td className="text-center">
                {isEditing ? (
                  <input
                    type="date"
                    value={sub.examDate}
                    onChange={(e) => handleChange(idx, 'examDate', e.target.value)}
                  />
                ) : (
                  formatDateMMDDYYYY(sub.examDate)
                )}
              </td>
              <td className="text-center">
                {isEditing ? (
                  <>
                    <input type="text" value={sub.startTime} onChange={(e) => handleChange(idx, 'startTime', e.target.value)} className="w-16 mx-1"/>
                    -
                    <input type="text" value={sub.endTime} onChange={(e) => handleChange(idx, 'endTime', e.target.value)} className="w-16 mx-1"/>
                  </>
                ) : `${sub.startTime} - ${sub.endTime}`}
              </td>
              <td className="text-center">
                {isEditing ? <input type="text" value={sub.invigilator} onChange={(e) => handleChange(idx, 'invigilator', e.target.value)}/> :  sub.invigilatorName}
              </td>
              <td className="text-center">
                {isEditing ? <input type="text" value={sub.room} onChange={(e) => handleChange(idx, 'room', e.target.value)}/> : sub.room}
              </td>
              <td className="text-center">
                {isEditing ? <input type="text" value={sub.notes} onChange={(e) => handleChange(idx, 'notes', e.target.value)}/> : sub.notes}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ViewDatesheet;
